import script from "./SupportView.vue?vue&type=script&setup=true&lang=js"
export * from "./SupportView.vue?vue&type=script&setup=true&lang=js"

import "./SupportView.vue?vue&type=style&index=0&id=7f66160b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f66160b"]])

export default __exports__